import { Component, AfterViewInit, ElementRef, Renderer, ViewChild, OnChanges } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
enum MenuOrientation {
    STATIC,
    OVERLAY,
    HORIZONTAL
};

declare var jQuery: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

    layoutCompact = false;

    layoutMode: MenuOrientation = MenuOrientation.STATIC;

    darkMenu = false;

    profileMode = 'inline';

    rotateMenuButton: boolean;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    layoutContainer: HTMLDivElement;

    layoutMenuScroller: HTMLDivElement;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    documentClickListener: Function;

    resetMenu: boolean;

    menu: any[] = [];


    @ViewChild('layoutContainer') layourContainerViewChild: ElementRef;

    @ViewChild('layoutMenuScroller') layoutMenuScrollerViewChild: ElementRef;

    constructor(public renderer: Renderer, private storage: SessionStorageService) { }

     verificarMenu() {
         //const usuario = this.storage.retrieve('usuario');
         //this.menu = [];

        //  if (usuario) {


        //      if (usuario.tipo * 1 == 1) {
        //          console.log("inf");
        //          this.menu.push({ label: 'Informe Dependencia', icon: 'people', routerLink: ['/informe/ldep'] });
        //          this.menu.push({ label: 'Informe Facultad', icon: 'people', routerLink: ['/informe/lacad'] });
        //      }
        //      if (usuario.tipo * 1 == 2) {
        //          console.log("admin");
        //          this.menu.push({ label: 'Informe Dependencia', icon: 'people', routerLink: ['/informe/ldep'] });
        //          this.menu.push({ label: 'Informe Facultad', icon: 'people', routerLink: ['/informe/lacad'] });

        //          this.menu.push({ label: 'Configuración dependencia', icon: 'people', routerLink: ['/crud-dependencia'] });
        //          this.menu.push({ label: 'Configuración período', icon: 'people', routerLink: ['/crud-periodofiscal'] });
        //      }

        //  }
        // console.log(this.menu);
     }
    
    ngAfterViewInit() {
        const usuario = this.storage.retrieve('usuario');


        // if (usuario) {


        //     if (usuario.tipo * 1 == 1) {
        //         console.log("inf");
        //         let fac;
        //         let dep;
        //         for (const iterator of usuario.dependencia) {
        //             if (iterator.facultadchk == true) {
        //                 fac = true;
        //             }
        //             if (iterator.dependenciachk == true) {
        //                 dep = true;
        //             }
        //         }
        //         if(fac){
        //             this.menu.push({ label: 'Informe Dependencia', icon: 'people', routerLink: ['/informe/ldep'] });
        //         }
        //        if(dep){
        //         this.menu.push({ label: 'Informe Facultad', icon: 'people', routerLink: ['/informe/lacad'] });
        //        }
               
        //     }
        //     if (usuario.tipo * 1 == 2) {
        //         console.log("admin");
        //         this.menu.push({ label: 'Informe Dependencia', icon: 'people', routerLink: ['/informe/ldep'] });
        //         this.menu.push({ label: 'Informe Facultad', icon: 'people', routerLink: ['/informe/lacad'] });

        //         this.menu.push({ label: 'Configuración dependencia', icon: 'people', routerLink: ['/crud-dependencia'] });
        //         this.menu.push({ label: 'Configuración período', icon: 'people', routerLink: ['/crud-periodofiscal'] });
        //     }

        // }
        //this.layoutContainer = <HTMLDivElement>this.layourContainerViewChild.nativeElement;
        
        //this.documentClickListener = this.renderer.listenGlobal('body', 'click', (event) => {
        //    if (!this.topbarItemClick) {
        //        this.activeTopbarItem = null;
        //        this.topbarMenuActive = false;
        //    }

        //    if (!this.menuClick && this.isHorizontal()) {
        //        this.resetMenu = true;
        //    }

        //    this.topbarItemClick = false;
        //    this.menuClick = false;
        //});

        //setTimeout(() => {
        //    jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
        //}, 10);
    }

    onMenuButtonClick(event) {
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;

        if (this.layoutMode === MenuOrientation.OVERLAY) {
            this.overlayMenuActive = !this.overlayMenuActive;
        } else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = true;

        if (!this.isHorizontal()) {
            setTimeout(() => {
                jQuery(this.layoutMenuScroller).nanoScroller();
            }, 500);
        }
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
            this.rotateMenuButton = false;
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
        }

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }
        event.preventDefault();
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.layoutMode === MenuOrientation.OVERLAY;
    }

    isHorizontal() {
        return this.layoutMode === MenuOrientation.HORIZONTAL;
    }

    changeToStaticMenu() {
        this.layoutMode = MenuOrientation.STATIC;
    }

    changeToOverlayMenu() {
        this.layoutMode = MenuOrientation.OVERLAY;
    }

    changeToHorizontalMenu() {
        this.layoutMode = MenuOrientation.HORIZONTAL;
    }

    // tslint:disable-next-line:use-life-cycle-interface
    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }

        jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts